export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NotSpecified = 'NOT_SPECIFIED',
}

export enum Role {
  SuperAdmin = 'SuperAdmin',  
}


export type User = {
  userId: string;
  name: string | null;
  email: string | null; 
  phoneNumber:string | null ;
  isActive : boolean ;
  role: string ;
  roleType : string ;
  userName : string ;
  totalUnReadNotification:number ;
  rolePermission:LoginUserRolePermission;
};

export type NotificationList = {
  id: string;
  title: string | null;
  description: string | null; 
  isRead:string | null ;
  createdOn : boolean ;  
};


export type UnreadNotificationCount = {
  totalUnreadCount: number;
  
};



export type PermissionFlags = {
  add: boolean;
  delete: boolean;
  edit: boolean;
  view: boolean;
  print: boolean;
};

export type LoginUserRolePermission = {
  menuId: number;
  menuKey: string;
  permissions: PermissionFlags;
};



export interface ProtectedRouteProps {
  pageKey: string;
  required: keyof PermissionFlags;
  children: React.ReactNode;
  redirectPath:string
}

      
export type RolePermissions = {
  userId: string;
  name: string | null;
  email: string | null; 
  phoneNumber:string | null ;
  isActive : boolean ;
  role: string ;
  roleType : string ;
 
};

export type PermissionRow ={
  menuId : number ;
  userId : number ;
  key: string;
  title: string;
  parentKey?: string | null;
  permissions: Record<string, boolean>;
}